// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__dE_dF","logoWrapper":"Navbar_logoWrapper__9kiVG","logo":"Navbar_logo__TY2uN","button":"Navbar_button__T8iZm","buttonText":"Navbar_buttonText__2wRUO"};